// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE];
const shareApi = {
  getShareWithEmailsList(payload) {
    return client.get(`/share/shares/${payload.campaignId}?type=${payload.shareType}`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  postShareWithEmailsList(payload) {
    return client.post(`/share/shares/${payload.campaignId}`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  resendShareWithEmail(payload) {
    return client.post(`/share/shares/${payload.campaignId}/resend`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  deleteEmailFromShareWith(payload) {
    return client.delete(`/share/shares/${payload.campaignId}?type=${payload.shareType}`, { data: payload.body })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};
export default shareApi;
